import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { ProductBillingRule, BillingRuleAssignment, ProductBillingRuleType, ProductBillingRuleSubType } from 'src/app/models/productBilling';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { tap } from 'rxjs/operators';
import { NgbModal, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-billing-modal',
  templateUrl: './product-billing-modal.component.html',
  styleUrls: ['./product-billing-modal.component.less']
})
export class ProductBillingModalComponent implements OnInit{
  @Input() dupeRules : ProductBillingRule[];
  rules : ProductBillingRule[];
  locationId : number;
  saved : EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public locations : PropertyService, public modalsrv : NgbModal, public toast : ToastrService){}
  ngOnInit(): void {
      // this.model = new ProductBillingRule();
      this.locations.GetBillingRules().pipe(tap(_=>{
        this.rules = _;
      })).subscribe();
  }
  model : ProductBillingRule;
  assignment :BillingRuleAssignment;

  cancel(){
    this.modalsrv.dismissAll();
  }

  saveRule(){
    if(this.dupeRules.find(rl=> { return rl.ruleName == this.model.ruleName && rl.ruleType == this.model.ruleType;}))
    {
        this.toast.error('Duplicate Product Billing Rules are not supported.');
        this.modalsrv.dismissAll();
        return;
    }
    this.assignment = new BillingRuleAssignment();
    
    this.assignment.Rule = this.model;
    this.assignment.PropertyId = this.locationId;
    if(this.model.subType != ProductBillingRuleSubType.Default){
      if(this.model.billingRuleOverridePrice == 0 || !this.model.billingRuleOverridePrice) this.model.billingRuleOverridePrice = this.model.transactionFee;
      this.assignment.billingRuleOverridePrice = this.model.billingRuleOverridePrice;

      this.assignment.DateObj = new Date();
    }

    if(this.model.additionalItemFee){
      this.assignment.additionalItemFee = this.model.additionalItemFee;
    }
    if(this.model.goLiveDate){
      var dt = new Date(`${this.model.goLiveDate.year}-${this.model.goLiveDate.month}-${this.model.goLiveDate.day}`)
      this.model.goLiveDate = dt;
      this.assignment.DateObj = this.model.goLiveDate;
    }else 
      this.assignment.DateObj = new Date();
    this.model.goLiveDate = null;
    // console.log(this.assignment);
    this.locations.SaveBillingRule(this.assignment).subscribe(()=>{
      this.toast.success('Billing Rule Saved');
      this.saved.emit(true);
    },()=>{
      this.toast.error('Bililng Rule Failed to save')
    },()=>{
      this.modalsrv.dismissAll();
    })
  }
}
